import React from 'react';
import { Button, Typography } from '@mui/material';


/**
 * A reusable button component with a typography child element.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.text - The button text. Defaults to 'Redundance Supervisor'.
 * @param {string} props.variant - The button variant. Defaults to 'outlined'.
 * @param {string} props.color - The button color. Defaults to 'primary'.
 * @param {Function} props.onClick - The callback function to be executed when the button is clicked.
 */
const RedundantSupervisor = ({
  text,
  variant,
  color,
  onClick, 
  selected
}) => {
  return (
    <Button
      size="small"
      /**
       * The button variant, defaults to 'outlined' if not provided.
       */
      variant={variant || 'outlined'}
      /**
       * The button color, defaults to 'primary' if not provided.
       */
      color={color || 'primary'}
      /**
       * The callback function to be executed when the button is clicked, passing 100 as an argument.
       */
      onClick={() => onClick()}
      sx={{
        fontFamily: 'Open Sans',
         color: selected ? '#fff' : '#363636',       
          width: { xs: '100%', sm: '100%', md: '90%' },
        height: { xs: 'auto', sm: '40px' },
        padding: '10px 20px',
        margin: '0 10px',
        textTransform: 'none',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflow: 'hidden',
        fontSize: '16px'
      }}
    >
      <Typography
        variant="button"
        sx={{
          fontSize: { xs: 'clamp(10px, 4vw, 12px)', sm: 'clamp(12px, 3vw, 14px)', md: 'clamp(14px, 2vw, 16px)' },
          textTransform: 'none',
          lineHeight: { xs: '1.2', sm: '1.4', md: '1.6' },
          letterSpacing: { xs: '0.5px', sm: '0.8px', md: '1px' },
          textAlign: 'center'
        }}
      >
        {text || 'Redundance Supervisor'}
      </Typography>
    </Button>
  )
}

/**
 * The default export of the RedundantSupervisor component.
 */
export default RedundantSupervisor;